<div class="brn-table-actions" [ngClass]="{'brn-table-actions_active': active}" #actions>
  <ng-content></ng-content>
</div>
